import { ImageStoreState, StylovyzeStoreState } from '../types';
import { useSelector } from 'react-redux';

export const selectImages = (state: StylovyzeStoreState): ImageStoreState =>
	state.images;

export const useSelectImages = (): ImageStoreState => {
	return useSelector(selectImages);
};
